// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const resetVisibility = () => getClaimDefaultState().isNonTrackedPinModalVisible;

const setVisibility = (state, action) => action.isVisible;

export default (state = getClaimDefaultState().isNonTrackedPinModalVisible, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_NORMAL]: resetVisibility,
        [actions.UPDATE_CLAIM_NORMAL_CREATE_PIN_MODAL_VISIBILITY]: setVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/normal/reducers/is-non-tracked-pin-modal-visible.js